<template>
	<div>
		<el-page-header @back="goBack" content="关联设置"></el-page-header>	
		<div class="relation-outer">
			<div class="relation-center fonts">
				<div class="pub-line">
					<span>测评名称：</span>
					<span class="glay">{{ examInfo.name }}</span>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>分类：</span>
						<span class="glay">{{ examInfo.categoryName1 }}-{{ examInfo.categoryName }}</span>
					</div>
					<div class="fl1">
						<span>标识：</span>
						<span class="glay">{{ examInfo.examId }}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 关联评测 -->
		<div class="relation-outer">
			<div class="relation-center fonts">
				<div class="section-title">
					<span>关联评测</span>
					<el-button type="primary" size="small" @click="handleAddRelation('exam')">
						<i class="el-icon-plus"></i> 添加关联评测
					</el-button>
				</div>
				
				<div class="public-table-data" style="margin-top: 20px;">
					<el-table
						:data="relationExamList"
						border
						style="width: 100%"
						v-loading="loading"
					>
						<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
						<el-table-column prop="name" label="评测名称" align="center"></el-table-column>
						<el-table-column prop="categoryName" label="分类" width="200" align="center">
							<template slot-scope="scope">
								{{ scope.row.categoryName1 }}-{{ scope.row.categoryName }}
							</template>
						</el-table-column>
						<el-table-column prop="examId" label="标识" width="150" align="center"></el-table-column>
						<el-table-column prop="seq" label="排序" width="100" align="center">
							<template slot-scope="scope">
								<el-input
									v-model="scope.row.seq"
									size="mini"
									@blur="updateRelationSort(scope.row, 'exam')"
								></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="120" align="center">
							<template slot-scope="scope">
								<el-button
									size="mini"
									type="danger"
									plain
									@click="handleDeleteRelation(scope.row, 'exam')"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<!-- 关联课程 -->
		<div class="relation-outer">
			<div class="relation-center fonts">
				<div class="section-title">
					<span>关联课程</span>
					<el-button type="primary" size="small" @click="handleAddRelation('course')">
						<i class="el-icon-plus"></i> 添加关联课程
					</el-button>
				</div>
				
				<div class="public-table-data" style="margin-top: 20px;">
					<el-table
						:data="relationCourseList"
						border
						style="width: 100%"
						v-loading="loading"
					>
						<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
						<el-table-column prop="name" label="课程名称" align="center"></el-table-column>
						<el-table-column prop="categoryName" label="分类" width="200" align="center">
							<template slot-scope="scope">
								{{ scope.row.parentCategoryName }}-{{ scope.row.categoryName }}
							</template>
						</el-table-column>
						<el-table-column prop="courseId" label="课程ID" width="150" align="center">
							<template slot-scope="scope">
								{{ scope.row.id }}
							</template>
						</el-table-column>
						<el-table-column prop="seq" label="排序" width="100" align="center">
							<template slot-scope="scope">
								<el-input
									v-model="scope.row.seq"
									size="mini"
									@blur="updateRelationSort(scope.row, 'course')"
								></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="120" align="center">
							<template slot-scope="scope">
								<el-button
									size="mini"
									type="danger"
									plain
									@click="handleDeleteRelation(scope.row, 'course')"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<!-- 添加关联评测弹框 -->
		<el-dialog
			title="添加关联评测"
			:visible.sync="dialogExamVisible"
			width="800px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form label-width="80px">
					<el-form-item label="搜索">
						<el-input
							v-model="examSearchKeyword"
							placeholder="请输入评测名称搜索"
							@input="handleExamSearchChange"
							clearable
						></el-input>
					</el-form-item>
				</el-form>
				
				<div class="public-table-data">
					<el-table
						ref="examTable"
						:data="availableExamList"
						@selection-change="handleExamSelectionChange"
						style="width: 100%"
					>
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="name" label="评测名称" align="center"></el-table-column>
						<el-table-column prop="categoryName" label="分类" width="200" align="center">
							<template slot-scope="scope">
								{{ scope.row.categoryName1 }}-{{ scope.row.categoryName }}
							</template>
						</el-table-column>
						<el-table-column prop="examId" label="标识" width="150" align="center"></el-table-column>
					</el-table>
					<div class="pagination-container">
						<el-pagination
							@current-change="handleExamPageChange"
							@size-change="handleExamSizeChange"
							:current-page="examPagination.pageNo"
							:page-size="examPagination.pageSize"
							:total="examPagination.count"
							layout="total, sizes, prev, pager, next, jumper"
							small
						></el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogExamVisible = false">取消</el-button>
				<el-button size="medium" type="primary" @click="submitExamRelation">确定</el-button>
			</span>
		</el-dialog>

		<!-- 添加关联课程弹框 -->
		<el-dialog
			title="添加关联课程"
			:visible.sync="dialogCourseVisible"
			width="800px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form label-width="80px">
					<el-form-item label="搜索">
						<el-input
							v-model="courseSearchKeyword"
							placeholder="请输入课程名称搜索"
							@input="handleCourseSearchChange"
							clearable
						></el-input>
					</el-form-item>
				</el-form>
				
				<div class="public-table-data">
					<el-table
						ref="courseTable"
						:data="availableCourseList"
						@selection-change="handleCourseSelectionChange"
						style="width: 100%"
					>
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="name" label="课程名称" align="center"></el-table-column>
						<el-table-column prop="categoryName" label="分类" width="200" align="center">
							<template slot-scope="scope">
								{{ scope.row.parentCategoryName }}-{{ scope.row.categoryName }}
							</template>
						</el-table-column>
						<el-table-column prop="id" label="课程ID" width="150" align="center"></el-table-column>
					</el-table>
					<div class="pagination-container">
						<el-pagination
							@current-change="handleCoursePageChange"
							@size-change="handleCourseSizeChange"
							:current-page="coursePagination.pageNo"
							:page-size="coursePagination.pageSize"
							:total="coursePagination.count"
							layout="total, sizes, prev, pager, next, jumper"
							small
						></el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogCourseVisible = false">取消</el-button>
				<el-button size="medium" type="primary" @click="submitCourseRelation">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { emptyShow, isEmpty } from "@utils/tools";

export default {
	name: "xltpRelationSet",
	data() {
		return {
			emptyShow,
			isEmpty,
			loading: false,
			examInfo: {},
			// 关联评测
			relationExamList: [],
			dialogExamVisible: false,
			availableExamList: [],
			examSearchKeyword: "",
			selectedExamList: [],
			// 添加分页相关数据
			examPagination: {
				pageNo: 1,
				pageSize: 10,
				totalPage: 0,
				count: 0
			},
			// 搜索防抖定时器
			searchTimer: null,
			// 关联课程
			relationCourseList: [],
			dialogCourseVisible: false,
			availableCourseList: [],
			courseSearchKeyword: "",
			selectedCourseList: [],
			// 添加课程分页相关数据
			coursePagination: {
				pageNo: 1,
				pageSize: 10,
				totalPage: 0,
				count: 0
			},
			// 课程搜索防抖定时器
			courseSearchTimer: null,
		};
	},
	mounted() {
		this.getExamInfo();
		this.getRelationExamList();
		this.getRelationCourseList();
	},
	beforeDestroy() {
		// 清理定时器
		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
		}
		if (this.courseSearchTimer) {
			clearTimeout(this.courseSearchTimer);
		}
	},
	methods: {
		/**
		 * 获取测评信息
		 */
		async getExamInfo() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.examInfo = resData.data;
		},
		
		/**
		 * 获取关联评测列表
		 */
		async getRelationExamList() {
			this.loading = true;
			try {
				const { data: resData } = await this.$get(
					`exam/recommend/exam/info/${this.$route.query.examId}`
				);
				this.loading = false;
				if (resData.result != 200) return;
				// 根据API返回的数据结构，获取推荐的测评ID列表
				if (resData.data && resData.data.recommendExamInfoIds) {
					// 根据ID列表获取详细信息
					this.getExamDetailsByIds(resData.data.recommendExamInfoIds);
				} else {
					this.relationExamList = [];
				}
			} catch (error) {
				this.loading = false;
				console.warn('获取关联评测API调用失败:', error);
				this.relationExamList = [];
			}
		},
		
		/**
		 * 根据测评ID列表获取详细信息
		 */
		async getExamDetailsByIds(examIds) {
			if (!examIds || examIds.length === 0) {
				this.relationExamList = [];
				return;
			}
			
			try {
				// 获取所有测评列表，然后过滤出指定的测评
				const { data: resData } = await this.$get(`exam/list`, {
					params: {
						pageNo: 1,
					    pageSize: 1000
					}
				});
				if (resData.result == 200 && resData.data) {
					this.relationExamList = resData.data.filter(item => 
						examIds.includes(item.examInfoId)
					).map((item, index) => ({
						...item,
						seq: index + 1 // 添加排序字段
					}));
				} else {
					this.relationExamList = [];
				}
			} catch (error) {
				console.warn('获取测评详情失败:', error);
				this.relationExamList = [];
			}
		},
		
		/**
		 * 获取关联课程列表
		 */
		async getRelationCourseList() {
			this.loading = true;
			try {
				const { data: resData } = await this.$get(
					`exam/recommend/course/info/${this.$route.query.examId}`
				);
				this.loading = false;
				if (resData.result != 200) return;
				// 根据API返回的数据结构，获取推荐的课程ID列表
				if (resData.data && resData.data.recommendCourseIds) {
					// 根据ID列表获取详细信息
					this.getCourseDetailsByIds(resData.data.recommendCourseIds);
				} else {
					this.relationCourseList = [];
				}
			} catch (error) {
				this.loading = false;
				console.warn('获取关联课程API调用失败:', error);
				this.relationCourseList = [];
			}
		},
		
		/**
		 * 根据课程ID列表获取详细信息
		 */
		async getCourseDetailsByIds(courseIds) {
			if (!courseIds || courseIds.length === 0) {
				this.relationCourseList = [];
				return;
			}
			
			try {
				// 使用课程列表API获取所有课程，然后过滤出指定的课程
				const { data: resData } = await this.$post(`course/info/list`, {
					page: 1,
					limit: 1000 // 获取足够多的数据
				});
				if (resData.result == 200 && resData.data) {
					this.relationCourseList = resData.data.filter(item => 
						courseIds.includes(item.id)
					).map((item, index) => ({
						...item,
						courseId: item.id, // 统一字段名
						seq: index + 1 // 添加排序字段
					}));
				} else {
					this.relationCourseList = [];
				}
			} catch (error) {
				console.warn('获取课程详情失败:', error);
				this.relationCourseList = [];
			}
		},
		
		/**
		 * 添加关联
		 */
		async handleAddRelation(type) {
			if (type === 'exam') {
				this.dialogExamVisible = true;
				// 重置分页参数
				this.examPagination.pageNo = 1;
				this.examSearchKeyword = "";
				this.searchExamList();
			} else if (type === 'course') {
				this.dialogCourseVisible = true;
				// 重置分页参数
				this.coursePagination.pageNo = 1;
				this.courseSearchKeyword = "";
				this.searchCourseList();
			}
		},
		
		/**
		 * 搜索可用评测列表
		 */
		async searchExamList() {
			this.loading = true;
			try {
				const { data: resData } = await this.$get(`exam/list`, {
					params: {
						pageNo: this.examPagination.pageNo,
						pageSize: this.examPagination.pageSize,
						searchKey: this.examSearchKeyword
					}
				});
				this.loading = false;
				if (resData.result == 200 && resData.data) {
					// 排除当前评测
					this.availableExamList = resData.data.filter(item => 
						item.examId !== this.$route.query.examId
					);
					// 更新分页信息
					this.examPagination.totalPage = resData.page.totalPage || 0;
					this.examPagination.count = resData.page.count || 0;
				} else {
					this.availableExamList = [];
					this.examPagination.totalPage = 0;
					this.examPagination.count = 0;
				}
			} catch (error) {
				this.loading = false;
				console.warn('搜索评测API调用失败:', error);
				this.availableExamList = [];
				this.examPagination.totalPage = 0;
				this.examPagination.count = 0;
			}
		},
		
		/**
		 * 搜索可用课程列表
		 */
		async searchCourseList() {
			this.loading = true;
			try {
				const { data: resData } = await this.$post(`course/info/list`, {
					page: this.coursePagination.pageNo,
					limit: this.coursePagination.pageSize,
					searchKey: this.courseSearchKeyword
				});
				this.loading = false;
				if (resData.result == 200 && resData.data) {
					this.availableCourseList = resData.data.map(item => ({
						...item,
						courseId: item.id // 统一字段名
					}));
					// 更新分页信息
					this.coursePagination.totalPage = resData.page.totalPage || 0;
					this.coursePagination.count = resData.page.count || 0;
				} else {
					this.availableCourseList = [];
					this.coursePagination.totalPage = 0;
					this.coursePagination.count = 0;
				}
			} catch (error) {
				this.loading = false;
				console.warn('搜索课程API调用失败:', error);
				this.availableCourseList = [];
				this.coursePagination.totalPage = 0;
				this.coursePagination.count = 0;
				this.$message.warning('课程列表获取失败，请联系管理员');
			}
		},
		
		/**
		 * 评测选择变化
		 */
		handleExamSelectionChange(selection) {
			this.selectedExamList = selection;
		},
		
		/**
		 * 课程选择变化
		 */
		handleCourseSelectionChange(selection) {
			this.selectedCourseList = selection;
		},
		
		/**
		 * 提交评测关联
		 */
		async submitExamRelation() {
			if (this.selectedExamList.length === 0) {
				this.$message.warning("请选择要关联的评测");
				return;
			}
			
			this.loading = true;
			try {
				// 获取当前已关联的测评ID列表
				const currentIds = this.relationExamList.map(item => item.examInfoId);
				// 合并新选择的测评ID
				const newIds = this.selectedExamList.map(item => item.examInfoId);
				const allIds = [...new Set([...currentIds, ...newIds])];
				
				const { data: resData } = await this.$post(
					`exam/recommend/exam/update`,
					{
						examId: this.$route.query.examId,
						examInfoId: this.examInfo.examInfoId,
						recommendExamInfoIds: allIds
					}
				);
				this.loading = false;
				if (resData.result != 200) return;
				
				this.$message.success("关联成功");
				this.dialogExamVisible = false;
				this.getRelationExamList();
			} catch (error) {
				this.loading = false;
				console.warn('提交评测关联API调用失败:', error);
				this.$message.warning('关联评测功能调用失败，请稍后重试');
			}
		},
		
		/**
		 * 提交课程关联
		 */
		async submitCourseRelation() {
			if (this.selectedCourseList.length === 0) {
				this.$message.warning("请选择要关联的课程");
				return;
			}
			
			this.loading = true;
			try {
				// 获取当前已关联的课程ID列表
				const currentIds = this.relationCourseList.map(item => item.id);
				// 合并新选择的课程ID
				const newIds = this.selectedCourseList.map(item => item.id);
				const allIds = [...new Set([...currentIds, ...newIds])];
				
				const { data: resData } = await this.$post(
					`exam/recommend/course/update`,
					{
						examId: this.$route.query.examId,
						examInfoId: this.examInfo.examInfoId,
						recommendCourseIds: allIds
					}
				);
				this.loading = false;
				if (resData.result != 200) return;
				
				this.$message.success("关联成功");
				this.dialogCourseVisible = false;
				this.getRelationCourseList();
			} catch (error) {
				this.loading = false;
				console.warn('提交课程关联API调用失败:', error);
				this.$message.warning('关联课程功能调用失败，请稍后重试');
			}
		},
		
		/**
		 * 删除关联
		 */
		async handleDeleteRelation(row, type) {
			this.$confirm("确认删除此关联关系？", "提示", {
				type: "warning",
			}).then(async () => {
				this.loading = true;
				try {
					if (type === 'exam') {
						// 获取当前关联的测评ID列表，移除要删除的项
						const currentIds = this.relationExamList.map(item => item.examInfoId);
						const newIds = currentIds.filter(id => id !== row.examInfoId);
						
						const { data: resData } = await this.$post(
							`exam/recommend/exam/update`,
							{
								examId: this.$route.query.examId,
								recommendExamInfoIds: newIds
							}
						);
						this.loading = false;
						if (resData.result != 200) return;
						
						this.$message.success("删除成功");
						this.getRelationExamList();
					} else if (type === 'course') {
						// 获取当前关联的课程ID列表，移除要删除的项
						const currentIds = this.relationCourseList.map(item => item.id);
						const newIds = currentIds.filter(id => id !== row.id);
						
						const { data: resData } = await this.$post(
							`exam/recommend/course/update`,
							{
								examId: this.$route.query.examId,
								recommendCourseIds: newIds
							}
						);
						this.loading = false;
						if (resData.result != 200) return;
						
						this.$message.success("删除成功");
						this.getRelationCourseList();
					}
				} catch (error) {
					this.loading = false;
					console.warn('删除关联API调用失败:', error);
					this.$message.warning('删除关联功能调用失败，请稍后重试');
				}
			});
		},
		
		/**
		 * 更新关联排序
		 */
		async updateRelationSort(row, type) {
			// 由于API不支持单独的排序更新，这里只做本地排序
			// 实际排序会在下次更新时生效
			this.$message.info("排序将在下次保存关联时生效");
		},
		
		/**
		 * 评测分页变化
		 */
		handleExamPageChange(page) {
			this.examPagination.pageNo = page;
			this.searchExamList();
		},
		
		/**
		 * 评测每页大小变化
		 */
		handleExamSizeChange(size) {
			this.examPagination.pageSize = size;
			this.examPagination.pageNo = 1;
			this.searchExamList();
		},
		
		/**
		 * 评测搜索关键词变化
		 */
		handleExamSearchChange() {
			// 清除之前的定时器
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			// 设置新的定时器，500ms后执行搜索
			this.searchTimer = setTimeout(() => {
				this.examPagination.pageNo = 1;
				this.searchExamList();
			}, 500);
		},
		
		/**
		 * 课程分页变化
		 */
		handleCoursePageChange(page) {
			this.coursePagination.pageNo = page;
			this.searchCourseList();
		},
		
		/**
		 * 课程每页大小变化
		 */
		handleCourseSizeChange(size) {
			this.coursePagination.pageSize = size;
			this.coursePagination.pageNo = 1;
			this.searchCourseList();
		},
		
		/**
		 * 课程搜索关键词变化
		 */
		handleCourseSearchChange() {
			// 清除之前的定时器
			if (this.courseSearchTimer) {
				clearTimeout(this.courseSearchTimer);
			}
			// 设置新的定时器，500ms后执行搜索
			this.courseSearchTimer = setTimeout(() => {
				this.coursePagination.pageNo = 1;
				this.searchCourseList();
			}, 500);
		},
		
		/**
		 * 返回上一页
		 */
		goBack() {
			this.$router.back();
		},
	},
};
</script>

<style scoped lang="scss">
.relation-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.relation-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;
}

.pub-line {
	margin-top: 30px;
}

.section-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 16px;
	font-weight: bold;
	margin-top: 30px;
	padding-bottom: 10px;
	border-bottom: 1px solid #e4e7ed;
}

.pagination-container {
	display: flex;
	justify-content: center;
	margin-top: 20px;
	padding: 10px 0;
}
</style> 